module.exports = __webpack_public_path__ + "static/media/ic_edit.a7058b50.svg";